import React from "react";

import Codeofconduct3 from "../component/Codeofconduct3.jsx";
import NavbarComponent from "../component/NavbarComponent.jsx";

const COCForm = () => (
  <div>
    <Codeofconduct3 />
  </div>
);

export default COCForm;
